<template>
    <div class="sa-flexbox" style="padding-bottom: 20px">
        <div class="sa-flexbox-header"></div>
        <div class="sa-flexbox-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <!-- <template #cell(firstname)="row">
                        <p>{{ row.item.lastname }} {{ row.item.firstname }}</p>
                    </template> -->
                    <template #cell(actions)="row">
                        <b-button variant="outline-danger" @click="onDeleteAssociazione(row.item)">
                            <b-icon icon="person-x-fill" aria-hidden="true"></b-icon>
                            Dissocia
                        </b-button>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "vue2-datepicker/index.css";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: {},
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/rsadiaripresidi",
            linkStrutture: "/strutture",
            pathResourceComune: "/comuni/istat",
            pathResourceUtentiPresidi: "/utentipresidi",
            showModalLoading: false,
            id: null,
            strutturePresidiAttivaSetting: false,
            jsonData: {
                denominazione: null,
                idStruttura: null,
                telefono: null,
                url: null,
                email: null,
                indirizzo: null,
                note: null,
                provincia: null,
                cap: null,
                fax: null,
                codiceAsl: "",
                codiceDistrettoAppartenenza: "",
                codicePresidio: "",
                tipologiaStruttura: null,
                tipologiaAssistenzaRiabilitativa: null,
                localita: null,
            },
            items: [],
            comune: "",
            listaStrutture: [],

            codiceStruttura: null,
            fields: [
                /* {
                    label: "Codice Diario",
                    key: "codiceDiario",
                    sortable: true,
                    thStyle: "width: 12rem",
                }, */
                {
                    label: "Codice Presidio",
                    key: "codicePresidio",
                    sortable: true,
                    thStyle: "width: 12rem",
                },
                {
                    label: "Denominazione",
                    key: "denominazionePresidio",
                    sortable: true,
                    thStyle: "width: 12rem",
                },
                {
                    label: "",
                    key: "actions",
                    tdClass: "text-right",
                },
            ],
            currentPage: 1,
            perPage: 1000,
        };
    },
    mounted: function () {
        // let me = this;
        // me.id = this.$route.params.id;
        //me.loadData();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        init(idDiario) {
            let me = this;
            me.idDiario = idDiario;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.loadDataResources(me.pathResource, { idDiario: me.idDiario }, me.resultResponseLoadData, me.resultErrorLoadData);
            // me.loadCodStrutture();
        },
        resultResponseLoadData(response) {
            let me = this;
            me.items = response.data.data.list;
        },
        resultErrorLoadData(error) {
            console.log(error);
        },
        onDeleteAssociazione(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm(this.getLabelTraduora("ambulatory.modelMessageConfirmDeleteAssociate"), {
                    title: this.getLabelTraduora("ambulatory.modelMessageDeleteAssociate"),
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteAssociazione(item);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteAssociazione(item) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
            axios
                .delete(link + item.id)
                .then((response) => {
                    console.log(response);
                    me.showModalLoading = false;
                    me.loadData();
                })
                .catch((error) => {
                    console.log(error);
                    me.showModalLoading = false;
                });
        },
    },
};
</script>
